export default function getDefaultConfigData() {
  const configuration = {
    API_URL: process.env.REACT_APP_API_URL,
    BASENAME: process.env.REACT_APP_BASENAME,
  };
  return configuration;
}
